import React from 'react';
import classNames from 'classnames';
import './loader.css';

 const Loading = ({ full = false, noTransparent }) => {
  return (
    <div
      className={classNames('selections-loading', {
        'selections-loading--full': full,
        'selections-loading-no-transparent': noTransparent,
      })}
    >
      <div className="selections-spinner" />
    </div>
  );
}

export default Loading